
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/githubactions",
      function () {
        return require("private-next-pages/services/githubactions/index.tsx");
      }
    ]);
  